import React from "react";
import { Mutation } from "@apollo/client/react/components";
import { getErrorDetails } from "../Utils/getErrorDetails";
import Button from "../SimpleForm/UI/Button";
import renderStatusModal from "./renderStatusModal";
import "../SimpleForm/StatusModal/modal.css";
import RecoilStateProvider from "./RecoilStateProvider";

const handleSave = (
  dataprop_name,
  updateFn,
  application_id,
  values,
  form_ui,
  form_ui_name,
  cleanData,
  profilePrefillMetadata,
  tablePagesErrors = []
) => {
  let data = cleanData(values);
  let vars = {};
  vars["id"] = application_id;
  vars[dataprop_name] = data;
  if (form_ui && form_ui.__typename) {
    delete form_ui.__typename;
  }
  const formPagesErrors = form_ui["pages_errors"];
  let formAndTablePagesErrors = [...formPagesErrors, ...tablePagesErrors];
  form_ui["pages_errors"] = [...new Set(formAndTablePagesErrors)];

  vars[form_ui_name] = form_ui;
  vars["profilePrefillMetadata"] = profilePrefillMetadata.profiles;

  updateFn({
    variables: vars,
  });
};

const renderSaveButton = (
  mutation,
  values,
  dataprop_name,
  application_id,
  cleanData,
  history,
  buttonLabel = "Save as Initiated",
  buttonColoring = "blue",
  extraAction,
  form_ui,
  form_ui_name,
  tablePagesErrors,
  isLocked
) => {
  return (
    <RecoilStateProvider>
      {({ profilePrefillMetadata, setProfilePrefillMetadata }) => (
        <Mutation
          mutation={mutation}
          onCompleted={(e) => renderStatusModal(true)}
          onError={(error) => {
            const { duration, message } = getErrorDetails(error);
            renderStatusModal(false, message, duration);
          }}
        >
          {(updateFn) => (
            <Button
              type="button"
              coloring={buttonColoring}
              disabled={isLocked?.current || false}
              onClick={() => {
                handleSave(
                  dataprop_name,
                  updateFn,
                  application_id,
                  values,
                  form_ui,
                  form_ui_name,
                  cleanData,
                  profilePrefillMetadata,
                  tablePagesErrors
                );
                if (extraAction !== undefined) {
                  extraAction();
                } else {
                  history.push(`/dashboard/application/`); // assume 'save & quit' if no action specified
                }

                setProfilePrefillMetadata((prev) => ({
                  ...prev,
                  profiles: [],
                }));
              }}
            >
              {buttonLabel}
            </Button>
          )}
        </Mutation>
      )}
    </RecoilStateProvider>
  );
};

export default renderSaveButton;
